import React from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../App';
import { isSeoSettingsNoFollow } from '../../data/seo/seoUtils';
import { useAbsolutePath } from '../../data/seo/seoRouteUtils';


function MatchLinkSearchBar(props) {
    const appContext = React.useContext(AppContext);
    const relativeMatchPath = useAbsolutePath([props.urlPath, props.urlPathSuffix].join(''),null,props.urlPathSeo,true);
    const noFollow = isSeoSettingsNoFollow(props.urlPathSeoSettings);

    function handleClick(e){
        if (window.blockHistoryChanges()) {
            e.preventDefault();
            props.openMatch();
        }else{
            appContext.setHandleOpenFromPath(true);
            props.openMatch();
        }
       
    }
    return (
        <Link to={encodeURI(relativeMatchPath) } onClick={handleClick} {...(noFollow ? {rel: 'nofollow'}:{})} >
            <div key={props.uniqueId} className="event-desc text-small" onClick={handleClick}>{props.alias} - {props.desc}</div>
        </Link>
    );
}

export default MatchLinkSearchBar;